import { asTranslationKey } from '../../common/translate-helpers/i18n-utils'

export const translationKeys = {
  activeTrialMessage: asTranslationKey(`Your trial expires in {{trialDaysLeft}} days.`),
  activeFreeMessage: asTranslationKey('You are using a free version of GoTo.'),
  expiredTrialMessage: asTranslationKey('Your trial has expired'),
  buyButtonText: asTranslationKey('Buy Now'),
  upgradeButtonText: asTranslationKey('Upgrade Now'),
}
